module.exports = "https://bin.bnbstatic.com/_next/static/images/hanguo3-92512962e914dba61ee236fe7c488472.jpg";